import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const PhoneInTalk = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M41.6669 32.2919C39.1402 32.2956 36.6293 31.8947 34.2294 31.1044C33.8631 30.9877 33.472 30.9726 33.0978 31.0606C32.7235 31.1487 32.3802 31.3366 32.1044 31.6044L27.5206 36.1875C21.6066 33.1795 16.7996 28.3723 13.7919 22.4581L18.375 17.8544C18.6509 17.5926 18.8464 17.2576 18.9386 16.8886C19.0308 16.5196 19.0159 16.132 18.8956 15.7712C18.1053 13.3714 17.7044 10.8604 17.7081 8.33375C17.7066 7.78167 17.4867 7.25262 17.0964 6.86218C16.7061 6.47174 16.1771 6.25165 15.625 6.25H8.33313C7.78115 6.25165 7.25226 6.47165 6.86195 6.86195C6.47165 7.25226 6.25165 7.78115 6.25 8.33313C6.24959 12.9843 7.16539 17.5899 8.94511 21.8871C10.7248 26.1842 13.3336 30.0887 16.6224 33.3776C19.9113 36.6664 23.8158 39.2752 28.1129 41.0549C32.4101 42.8346 37.0157 43.7504 41.6669 43.75C42.2188 43.7484 42.7477 43.5284 43.138 43.138C43.5284 42.7477 43.7484 42.2188 43.75 41.6669V34.375C43.7484 33.823 43.5284 33.2941 43.138 32.9038C42.7477 32.5135 42.2188 32.2935 41.6669 32.2919ZM39.5831 25H43.75C43.75 20.0272 41.7746 15.2581 38.2583 11.7417C34.7419 8.22544 29.9728 6.25 25 6.25V10.4169C26.9155 10.4155 28.8124 10.7917 30.5824 11.5241C32.3523 12.2565 33.9605 13.3306 35.3149 14.6851C36.6694 16.0395 37.7435 17.6477 38.4759 19.4176C39.2083 21.1876 39.5845 23.0845 39.5831 25ZM31.25 25H35.4169C35.4159 22.2376 34.3181 19.5886 32.3647 17.6353C30.4114 15.6819 27.7624 14.5841 25 14.5831V18.75C25.8211 18.7489 26.6343 18.9099 27.393 19.2236C28.1518 19.5373 28.8412 19.9976 29.4218 20.5782C30.0024 21.1588 30.4627 21.8482 30.7764 22.607C31.0901 23.3657 31.2511 24.1789 31.25 25Z"
        fill={color}
      />
    </svg>
  )
}
